import { Validator } from 'fluentvalidation-ts';
import { beGreaterThanOrEqualTo, haveDecimalPlaces } from '../../../../../validators/stringValidators';

export type RoomWallHeatLossDetailsFormModel = {
  outsideWallLengthInMetres: string;
  additionalWallAreaInMetresSquared: string;
  windowAreaInMetresSquared: string;
  doorAreaInMetresSquared: string;
  externalAirTemperatureInDegreesCelsius: string;
};

export const getNewRoomWallHeatLossDetailsFormModel = (
  externalAirTemperatureInDegreesCelsius: number | string,
): RoomWallHeatLossDetailsFormModel => ({
  outsideWallLengthInMetres: '',
  additionalWallAreaInMetresSquared: '0',
  windowAreaInMetresSquared: '',
  doorAreaInMetresSquared: '0',
  externalAirTemperatureInDegreesCelsius: externalAirTemperatureInDegreesCelsius.toString(),
});

export class RoomWallHeatLossDetailsFormModelValidator extends Validator<RoomWallHeatLossDetailsFormModel> {
  constructor(heatLossDetailsAreRequired: boolean) {
    super();

    this.ruleFor('outsideWallLengthInMetres')
      .must(beGreaterThanOrEqualTo(0))
      .must(haveDecimalPlaces(1));

    this.ruleFor('outsideWallLengthInMetres')
      .notEmpty()
      .when(() => heatLossDetailsAreRequired);

    this.ruleFor('additionalWallAreaInMetresSquared')
      .must(beGreaterThanOrEqualTo(0))
      .must(haveDecimalPlaces(1));

    this.ruleFor('additionalWallAreaInMetresSquared')
      .notEmpty()
      .when(model => heatLossDetailsAreRequired && Number(model.outsideWallLengthInMetres) !== 0);

    this.ruleFor('windowAreaInMetresSquared')
      .must(beGreaterThanOrEqualTo(0))
      .must(haveDecimalPlaces(1));

    this.ruleFor('windowAreaInMetresSquared')
      .notEmpty()
      .when(model => heatLossDetailsAreRequired && Number(model.outsideWallLengthInMetres) !== 0);

    this.ruleFor('doorAreaInMetresSquared')
      .must(beGreaterThanOrEqualTo(0))
      .must(haveDecimalPlaces(1));

    this.ruleFor('doorAreaInMetresSquared')
      .notEmpty()
      .when(model => heatLossDetailsAreRequired && Number(model.outsideWallLengthInMetres) !== 0);

    this.ruleFor('externalAirTemperatureInDegreesCelsius').must(haveDecimalPlaces(1));

    this.ruleFor('externalAirTemperatureInDegreesCelsius')
      .notEmpty()
      .when(model => heatLossDetailsAreRequired && Number(model.outsideWallLengthInMetres) !== 0);
  }
}
